import{adoptStyles as t}from"@lit/reactive-element/css-tag.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function e(e){return class extends e{createRenderRoot(){const e=this.constructor,{registry:s,elementDefinitions:n,shadowRootOptions:o}=e;n&&!s&&(e.registry=new CustomElementRegistry,Object.entries(n).forEach((([t,s])=>e.registry.define(t,s))));const i=this.renderOptions.creationScope=this.attachShadow({...o,customElements:e.registry});return t(i,this.constructor.elementStyles),i}}}export{e as ScopedRegistryHost};
//# sourceMappingURL=scoped-registry-mixin.js.map
